export const homeObjThree = {
    id: 'signup',
    lightBg: true,
    lightText: true,
    lightTextDesc: false,
    topLine: '1200 West Shore Dr',
    headline: 'Richardson, TX',
    description: 'Ebenezer Dallas Gerizim',
    buttonLabel: 'Dirección',
    imgStart: false,
    img: "https://images.squarespace-cdn.com/content/v1/60786b55d8b624331628c2e9/c9e5596e-8cef-447e-b196-eba6b6b9343a/Dallas.jpg?format=2500w",
    alt: 'Ubicacion',
    dark: false,
    primary: false,
    darkText: false
};